module.exports = __webpack_public_path__ + "static/media/pdf.5e2994cc.svg";